export const LABEL = {
  STRATA: 'Stratify By'
}

export const SLIDER_VALUES = [
  { value: 0, label: '0%' },
  { value: 0.2, label: '20%' },
  { value: 0.4, label: '40%' },
  { value: 0.6, label: '60%' },
  { value: 0.8, label: '80%' },
  { value: 1, label: '100%' }
]
